// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c7dc5cff","703":"bad1e88a"}[chunkId] + ".chunk.js";
};